import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import UsermanMenu from "../components/UsermanMenu.js";

const UsermanAttribute = () => {
  const [searchParams] = useSearchParams();
  const usermanId = searchParams.get("userman_id");
  const deviceName = searchParams.get("device_name");

  const [attributes, setAttributes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("");
  const [filterName, setFilterName] = useState("");

  const showToast = (message, type) => {
    setToastMessage(message);
    setToastType(type);
    setTimeout(() => setToastMessage(""), 3000);
  };

  const fetchAttributes = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `https://api.wifikamu.my.id/userman-attribute-get/${usermanId}`
      );
      if (!response.ok) {
        throw new Error("Gagal mengambil data dari API.");
      }
      const result = await response.json();
      if (result.success) {
        setAttributes(result.data);
        showToast("Data atribut berhasil dimuat.", "success");
      } else {
        throw new Error(result.message || "Gagal mengambil data atribut.");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      showToast(`Error: ${error.message}`, "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAttributes();
  }, []);

  const filteredAttributes = attributes.filter((attr) =>
    attr.name.toLowerCase().includes(filterName.toLowerCase())
  );

  return (
    <div className="p-6 font-sans antialiased text-gray-800 dark:bg-gray-900 dark:text-gray-200 min-h-screen">
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
          body { font-family: 'Inter', sans-serif; }
        `}
      </style>

      {/* Toast Notification */}
      {toastMessage && (
        <div
          className={`fixed top-4 right-4 z-50 px-6 py-3 rounded-xl shadow-lg transition-all duration-300 ease-in-out ${
            toastType === "success"
              ? "bg-green-500 text-white"
              : "bg-red-500 text-white"
          }`}
        >
          {toastMessage}
        </div>
      )}

      {/* Main Content */}
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold flex items-center gap-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-book-open"
          >
            <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
            <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
          </svg>
          {deviceName} /
          <UsermanMenu userman_id={usermanId} device_name={deviceName} />/
          Attribute
        </h1>
        <button
          className="bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded-xl flex items-center gap-2 shadow-md"
          onClick={fetchAttributes}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-refresh-cw"
          >
            <path d="M21 12A9 9 0 0 0 6 21c-2.7-.7-4.5-2.5-6-4.5" />
            <path d="M3 12A9 9 0 0 1 18 3c2.7.7 4.5 2.5 6 4.5" />
            <path d="M17.5 14.5-1.5 8.5" />
            <path d="M22 12s-4 2-6 2-6-2-12-2-6 2-6 2v2s4-2 6-2 6 2 12 2 6-2 6-2Z" />
          </svg>
          Sinkronisasi
        </button>
      </div>

      {/* Filter Section */}
      <div className="mb-4 p-4 rounded-xl shadow bg-white dark:bg-gray-800">
        <h2 className="text-xl font-semibold mb-2">Filter Data</h2>
        <input
          className="w-full border text-black dark:text-white border-gray-300 dark:border-gray-700 bg-gray-50 dark:bg-gray-700 px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
          type="text"
          placeholder="Filter berdasarkan Nama Atribut"
          value={filterName}
          onChange={(e) => setFilterName(e.target.value)}
        />
      </div>

      {/* Main Table */}
      {loading ? (
        <div className="flex justify-center items-center h-64">
          <div className="w-16 h-16 border-4 border-blue-500 border-dashed rounded-full animate-spin"></div>
        </div>
      ) : (
        <div className="overflow-x-auto rounded-xl shadow bg-white dark:bg-gray-800">
          <table className="min-w-full text-sm">
            <thead className="bg-gray-100 dark:bg-gray-700">
              <tr>
                <th className="p-3 text-left font-semibold">Nama Atribut</th>
                <th className="p-3 text-left font-semibold">Tipe Nilai</th>
                <th className="p-3 text-left font-semibold">Vendor ID</th>
                <th className="p-3 text-left font-semibold">Tipe Paket</th>
              </tr>
            </thead>
            <tbody>
              {filteredAttributes.map((attr) => (
                <tr key={attr[".id"]} className="border-t dark:border-gray-700">
                  <td className="p-3">{attr.name}</td>
                  <td className="p-3">{attr["value-type"]}</td>
                  <td className="p-3">{attr["vendor-id"]}</td>
                  <td className="p-3">{attr["packet-types"]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default UsermanAttribute;
